import { Theme } from '@mui/material/styles'

export const styles = {
  inlineWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      marginLeft: (theme: Theme) => theme.spacing(1),
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '34px',
    height: '34px',
    pointerEvents: 'all',
    '& svg': {
      display: 'block',
    },
  },
  warning: {
    color: (theme: Theme) => theme.palette.warning.main,
  },
  error: {
    color: (theme: Theme) => theme.palette.error.main,
  },
  success: {
    color: (theme: Theme) => theme.palette.success.main,
  },

  cell: {
    borderBottom: 'none',
  },
}

export const classes = {
  columnHeader: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
}
